import React from 'react';
import DigitalCardEffect from 'src/components/_common/DigitalCard/_components/DigitalCardEffect';
import DigitalCardLayerStyled from 'src/components/_common/DigitalCard/_components/DigitalCardLayer/index.styled';
import type { EffectLayer } from 'src/components/_common/DigitalCard/_components/DigitalCardLayer/types';
import styled from 'styled-components';

export type EffectType = 'glare' | 'light' | 'glow';

/**
 * [효과 레이어 컴포넌트]
 *
 * @description
 * effectType에 따라 적절한 효과 컴포넌트를 렌더링합니다.
 * glow 타입은 effectProps를 통해 추가 속성을 전달받습니다.
 */
export const DigitalCardEffectLayer = (props: EffectLayer) => {
  const { zIndex, translateZ, borderRadius, effectType } = props;

  const renderEffect = () => {
    switch (effectType) {
      case 'glare':
        return <DigitalCardEffect.Glare />;
      case 'light':
        return <DigitalCardEffect.Light />;
      case 'glow':
        return <DigitalCardEffect.Glow {...props.effectProps} borderRadius={borderRadius} />;
      default:
        console.warn(`Unknown effect type: ${effectType}`);
        return null;
    }
  };

  return (
    <EffectLayerWrapper $zIndex={zIndex} $translateZ={translateZ} $borderRadius={borderRadius} $effectType={effectType}>
      {renderEffect()}
    </EffectLayerWrapper>
  );
};

const EffectLayerWrapper = styled(DigitalCardLayerStyled.BaseLayerWrapper)<{ $effectType: EffectType }>`
  overflow: ${({ $borderRadius, $effectType }) => (!$borderRadius || $effectType === 'glow' ? 'visible' : 'hidden')};
  ${({ $borderRadius, $effectType }) => ($borderRadius && $effectType !== 'glow' ? `border-radius: ${$borderRadius}px;` : '')}
`;
